// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3j13f","errorLogs":"EditorFooter_errorLogs__3epyK"};